import React, { createContext, useContext, useState, useEffect } from 'react';

// Theme definitions
export const themes = [
  { 
    id: 'light', 
    name: 'Light', 
    icon: '☀️',
    preview: { bg: '#F0F2F5', card: '#FFFFFF', accent: '#D4AF37' }
  },
  { 
    id: 'charcoal', 
    name: 'Charcoal', 
    icon: '🌑',
    preview: { bg: '#1F1F1F', card: '#2C2C2C', accent: '#D4AF37' }
  },
  { 
    id: 'midnight', 
    name: 'Midnight', 
    icon: '🌙',
    preview: { bg: '#0F172A', card: '#1E293B', accent: '#D4AF37' }
  },
  { 
    id: 'ocean', 
    name: 'Ocean', 
    icon: '🌊',
    preview: { bg: '#0C1929', card: '#162033', accent: '#D4AF37' }
  }
];

const ThemeContext = createContext();

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(() => {
    // Get from localStorage or default to 'light'
    if (typeof window !== 'undefined') {
      return localStorage.getItem('bms-theme') || 'light';
    }
    return 'light';
  });

  useEffect(() => {
    // Save to localStorage
    localStorage.setItem('bms-theme', theme);
    
    // Update document class for Tailwind
    const root = document.documentElement;
    
    // Remove all theme classes
    themes.forEach(t => {
      root.classList.remove(`theme-${t.id}`);
    });
    
    // Add current theme class
    root.classList.add(`theme-${theme}`);
    
    // Also set dark class for Tailwind dark mode
    if (theme !== 'light') {
      root.classList.add('dark');
    } else {
      root.classList.remove('dark');
    }
  }, [theme]);

  const currentTheme = themes.find(t => t.id === theme) || themes[0];

  return (
    <ThemeContext.Provider value={{ theme, setTheme, themes, currentTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export default ThemeContext;
